module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-3-3b576eedd86e7d939cf023bc2b5f22ff.jpg";